import { evaluateCondition } from './evaluateCondition'
export function evaluateConditions (args) {
  return obj => {
    if (obj.condition) {
      return evaluateCondition({ obj, ...args })
    }
    return true
  }
}
